import { useRef as a, useEffect as m, useCallback as n } from "react";
import { usePLMapboxStoreV2 as c } from "./index.es6.js";
const p = 50, v = () => {
  const o = c((r) => r.actions.setHoverComponent), t = c((r) => r.actions.clearHoverComponent), e = a(null);
  m(() => () => {
    e.current && clearTimeout(e.current);
  }, []);
  const u = n(
    ({
      mapId: r,
      componentType: s,
      componentProps: i
    }) => {
      e.current && (clearTimeout(e.current), e.current = null), o({
        mapId: r,
        componentType: s,
        componentProps: i
      });
    },
    [o]
  ), l = n(
    ({ mapId: r }) => {
      e.current && clearTimeout(e.current), e.current = setTimeout(() => {
        t({ mapId: r }), e.current = null;
      }, p);
    },
    [t]
  );
  return {
    generateTooltip: u,
    clearHoverTooltip: l
  };
};
export {
  v as useHoverTooltip
};
//# sourceMappingURL=index.es186.js.map
